var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hocCard',{attrs:{"title":_vm.$t('PW_ACTIVATION_TITLE'),"subtitle":_vm.$t('PAGE_SUBTITLE'),"variant":"primary"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('areaPasswordForgottenActivation',{attrs:{"userkey":_vm.user_key}})]},proxy:true}])},[_vm._v("\n  "+_vm._s(_vm.user_key)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }